import { OPTIONS, type IntakeAnswers } from '@upm/domain';
import { Avatar, ChoiceGroup, TextArea } from '../../ui';
import { useIntake } from '../IntakeContext';
import { toggleMulti } from '../logic';
import { FormCard, opts, StepHeader } from './common';

type Interest = NonNullable<IntakeAnswers['interests']>[number];

/** Step 5: what the firm wants from the Discovery Session. Nothing here is required. */
export function StepQuestions() {
  const { answers: a, setAnswers, state } = useIntake();
  const set = (p: Partial<IntakeAnswers>) => setAnswers(5, p);
  return (
    <div className="flex flex-col gap-6">
      <StepHeader step={5} title="Your questions">Anything you’d like to cover in your Discovery Session? Tell us now and we’ll come prepared. Nothing here is required.</StepHeader>
      <FormCard>
        <ChoiceGroup
          legend="What are you most interested in hearing about?"
          hint="Pick any that apply."
          options={opts(OPTIONS.interests)}
          value={a.interests ?? []}
          onToggle={(v) => set({ interests: toggleMulti<Interest>(a.interests, v as Interest) })}
        />
        <TextArea
          id="questionsText"
          label="Questions for us"
          optional
          hint="Anything at all: features, how your team will work day to day, what changes for your clients."
          rows={4}
          value={a.questionsText ?? ''}
          onChange={(e) => set({ questionsText: e.target.value })}
        />
        <TextArea
          id="beforeMeetingText"
          label="Anything else we should know before we meet?"
          optional
          rows={3}
          value={a.beforeMeetingText ?? ''}
          onChange={(e) => set({ beforeMeetingText: e.target.value })}
        />
        <div className="flex items-center gap-2.5 rounded-[10px] bg-panel px-3 py-2.5 text-sm text-ink-2">
          <Avatar initials={state.lead.initials} size={28} tone="soft" />
          {state.lead.name} reads these before your Discovery Session.
        </div>
      </FormCard>
    </div>
  );
}
